export enum FingerprintEnum {
  DEFAULT = 'Unable to retrieve FP',
}
